enum FeaturesUsers {
  USERS = 'USERS',
  USERS_LIST = 'USERS_LIST',
  USERS_CREATE = 'USERS_CREATE',
  USERS_EDIT = 'USERS_EDIT',
  USERS_DELETE = 'USERS_DELETE',
  USERS_SHIFT = 'USERS_SHIFT',
  USERS_CALENDAR = 'USERS_CALENDAR',
}

enum FeatureOrders {
  ORDERS = 'ORDERS',
  ORDERS_HISTORY = 'ORDERS_HISTORY',
  ORDERS_CREATE = 'ORDERS_CREATE',
  ORDERS_VIEW = 'ORDERS_VIEW',
  ORDERS_COOK = 'ORDERS_COOK',
  ORDERS_EDIT = 'ORDERS_EDIT',
  ORDERS_CLOSED = 'ORDERS_CLOSED',
  ORDERS_OPEN = 'ORDERS_OPEN',
  ORDERS_CHECKOUT = 'ORDERS_CHECKOUT',
  ORDERS_ADD = 'ORDERS_ADD',
  ORDERS_DIVIDER = 'ORDERS_DIVIDER',
  ORDERS_DELETE = 'ORDERS_DELETE',
}

enum FeatureProducts {
  PRODUCTS = 'PRODUCTS',
  PRODUCTS_LIST = 'PRODUCTS_LIST',
  PRODUCTS_CREATE = 'PRODUCTS_CREATE',
  PRODUCTS_EDIT = 'PRODUCTS_EDIT',
  PRODUCTS_DELETE = 'PRODUCTS_DELETE',
}

enum FeatureCashRegister {
  CASH_REGISTER = 'CASH_REGISTER',
  CASH_REGISTER_LIST = 'CASH_REGISTER_LIST',
  CASH_REGISTER_DETAILS = 'CASH_REGISTER_DETAILS',
}

enum FeatureBranch {
  BRANCH = 'BRANCH',
  BRANCH_LIST = 'BRANCH_LIST',
  BRANCH_CREATE = 'BRANCH_CREATE',
  BRANCH_VIEW = 'BRANCH_VIEW',
  BRANCH_EDIT = 'BRANCH_EDIT',
  BRANCH_DELETE = 'BRANCH_DELETE',
}

enum FeatureMonitors {
  MONITORS = 'MONITORS',
  MONITORS_DAILY = 'MONITORS_DAILY',
  MONITORS_BY_DATE = 'MONITORS_BY_DATE',
  MONITORS_BY_lINE = 'MONITORS_BY_lINE',
  MONITORS_BY_CASH_REGISTER = 'MONITORS_BY_CASH_REGISTER',
  MONITOR_CANCEL_PRODUCTS = 'MONITOR_CANCEL_PRODUCTS',
  MONITOR_CANCEL_PRODUCTS_LIST = 'MONITOR_CANCEL_PRODUCTS_LIST',
  MONITOR_CANCEL_PRODUCTS_VIEW = 'MONITOR_CANCEL_PRODUCTS_VIEW',
}

enum FeatureLines {
  LINES = 'LINES',
  LINES_LIST = 'LINES_LIST',
  LINES_CREATE = 'LINES_CREATE',
  LINES_EDIT = 'LINES_EDIT',
  LINES_DELETE = 'LINES_DELETE',
}

enum FeatureInventory {
  INVENTORY = 'INVENTORY',
  INVENTORY_MODIFY = 'INVENTORY_MODIFY',
  INVENTORY_CREATE = 'INVENTORY_CREATE',
  INVENTORY_EDIT = 'INVENTORY_EDIT',
}

enum FeatureIngredients {
  SUPPLIES = 'SUPPLIES',
  SUPPLIES_GROUP = 'SUPPLIES_GROUP',
  SUPPLIES_LIST = 'SUPPLIES_LIST',
  SUPPLIES_CREATE = 'SUPPLIES_CREATE',
  SUPPLIES_EDIT = 'SUPPLIES_EDIT',
  SUPPLIES_DELETE = 'SUPPLIES_DELETE',
}

enum FeatureCategories {
  CATEGORIES = 'CATEGORIES',
  CATEGORIES_LIST = 'CATEGORIES_LIST',
  CATEGORIES_CREATE = 'CATEGORIES_CREATE',
  CATEGORIES_EDIT = 'CATEGORIES_EDIT',
}

enum FeaturePlan {
  PLAN = 'PLAN',
  PLAN_LIST = 'PLAN_LIST',
  PLAN_CREATE = 'PLAN_CREATE',
  PLAN_VIEW = 'PLAN_VIEW',
  PLAN_EDIT = 'PLAN_EDIT',
  PLAN_DELETE = 'PLAN_DELETE',
}

enum FeatureProviders {
  PROVIDERS = 'PROVIDERS',
  PROVIDERS_LIST = 'PROVIDERS_LIST',
  PROVIDERS_CREATE = 'PROVIDERS_CREATE',
  PROVIDERS_EDIT = 'PROVIDERS_EDIT',
  PROVIDERS_DELETE = 'PROVIDERS_DELETE',
}

enum FeatureRecipes {
  RECIPES = 'RECIPES',
  RECIPES_LIST = 'RECIPES_LIST',
  RECIPES_CREATE = 'RECIPES_CREATE',
  RECIPES_EDIT = 'RECIPES_EDIT',
  RECIPES_DELETE = 'RECIPES_DELETE',
}

enum FeatureReservations {
  RESERVATIONS = 'RESERVATIONS',
  RESERVATIONS_LIST = 'RESERVATIONS_LIST',
  RESERVATIONS_VIEW = 'RESERVATIONS_VIEW',
  RESERVATIONS_CREATE = 'RESERVATIONS_CREATE',
  RESERVATIONS_EDIT = 'RESERVATIONS_EDIT',
}

enum FeatureShopping {
  SHOPPING = 'SHOPPING',
  SHOPPING_LIST = 'SHOPPING_LIST',
  SHOPPING_CREATE = 'SHOPPING_CREATE',
  SHOPPING_EDIT = 'SHOPPING_EDIT',
  SHOPPING_DELETE = 'SHOPPING_DELETE',
}

enum FeaturesTables {
  TABLES = 'TABLES',
  TABLE_LIST = 'TABLE_LIST',
  TABLES_CREATE = 'TABLES_CREATE',
}

export const FeaturesEnum = {
  ...FeaturesUsers,
  ...FeatureOrders,
  ...FeatureProducts,
  ...FeatureCashRegister,
  ...FeatureBranch,
  ...FeatureMonitors,
  ...FeatureLines,
  ...FeatureInventory,
  ...FeatureIngredients,
  ...FeatureCategories,
  ...FeaturePlan,
  ...FeatureProviders,
  ...FeatureRecipes,
  ...FeatureReservations,
  ...FeatureShopping,
  ...FeaturesTables,
};

export type FeaturesType = keyof typeof FeaturesEnum;

export const Features: Array<FeaturesType> = Object.keys(FeaturesEnum) as Array<FeaturesType>;
